import React from 'react'

const BatchSmall = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 226.77 226.77">
            <polyline points="226.77 226.77 0 226.77 0 0" style={{ 'fill': '#ff0' }} />
            <path d="M45.11,129.21,23.91,140.9a5.68,5.68,0,0,1-2.38.65,1.75,1.75,0,0,1-1.52-2V118.18a3.78,3.78,0,0,1,2.38-3.25L49,99.35a5.9,5.9,0,0,1,3.24-1.08h15.8c1.51,0,2.16.65,2.16,2.16v104.3c0,1.52-.65,2.17-2.16,2.17H47.28c-1.52,0-2.17-.65-2.17-2.17Z" style={{ 'fill': '#f39' }}/>
            <path d="M157,96.11c-13,0-23.15,4.33-33.1,13.41-6.28-9.08-14.07-13.41-27-13.41a32.6,32.6,0,0,0-12.55,2.61,2,2,0,0,0-1.18,1.8v17.74A1.93,1.93,0,0,0,85,120.21a2,2,0,0,0,.55-.07,15.28,15.28,0,0,1,4.55-.66c9.52,0,14.06,4.54,14.06,19.47v65.78a2.17,2.17,0,0,0,2.17,2.17H128a2.17,2.17,0,0,0,2.16-2.17h0V156.48c0-24,7.14-37,20.34-37,8.87,0,13.63,4.11,13.63,18.39v66.86a2.17,2.17,0,0,0,2.17,2.17h21.64a2.17,2.17,0,0,0,2.16-2.17h0V134.19C190.09,110.6,179.27,96.11,157,96.11Z" style={{ 'fill': '#f39' }}/>
        </svg>
    )
}

export default BatchSmall
